export default __webpack_public_path__ + "static/media/ESHARE.89aee0be.png";